import React from 'react'
import s from './PanelBase.module.scss'

const GuardsPanel = ({
  guardsFilter,
  setGuardsFilter,
  filteredGuards,
  guardsPagination,
  loadGuardsPage,
}) => {
  return (
    <div className={s.panel}>
      <div className={s.header}>
        <h2 className={s.title}>Охрана КПП</h2>
        {guardsPagination?.count > 0 && (
          <span className={s.totalBadge}>Всего: {guardsPagination.count}</span>
        )}
      </div>

      <div className={s.searchRow}>
        <input className={s.searchInput} placeholder="Поиск по сотруднику..." value={guardsFilter} onChange={(e) => setGuardsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadGuardsPage(1, guardsFilter) }} />
      </div>

      {filteredGuards && filteredGuards.length ? (
        <div className={s.tableWrap}>
          <div className={s.tableScroll}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Сотрудник</th>
                <th>Телефон</th>
                <th>Доп. телефон</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {filteredGuards.map((g, index) => (
                <tr key={g.id}>
                  <td className={s.numCell}>{index + 1}</td>
                  <td style={{ fontWeight: 600, color: '#1e293b' }}>{g.employee_name || `#${g.id}`}</td>
                  <td>{g.employee_phone || '—'}</td>
                  <td>{g.phone || '—'}</td>
                  <td>
                    <span className={`${s.badge} ${g.is_active ? s.active : s.inactive}`}>
                      {g.is_active ? 'Активен' : 'Неактивен'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ) : (
        <div className={s.empty}>Список пуст</div>
      )}

      {!guardsFilter && guardsPagination?.count > 0 && (
        <div className={s.pagination}>
          <button className={s.pageBtn} disabled={!guardsPagination.previous} onClick={() => loadGuardsPage((guardsPagination.page || 1) - 1)}>Пред.</button>
          <span>Стр. {guardsPagination.page || 1} из {Math.ceil(guardsPagination.count / 25)}</span>
          <button className={s.pageBtn} disabled={!guardsPagination.next} onClick={() => loadGuardsPage((guardsPagination.page || 1) + 1)}>След.</button>
        </div>
      )}
    </div>
  )
}

export default GuardsPanel
